initVerticalSwipers = () => {
  const imageSwiper = new Swiper('#image-swiper', {
    effect: 'fade',
    height: document.getElementById('image-swiper').clientHeight,
  });

  function handleScroll() {
    const container = document.getElementById('image-swiper');
    const { bottom: containerBottom, top: containerTop } = container.getBoundingClientRect();
    let skip = false;

    document.querySelectorAll('.text-slide').forEach((elem, index) => {
      const { bottom: slideBottom, top: slideTop } = elem.getBoundingClientRect();

      if (slideTop + 200 > containerTop && skip === false) {
        skip = true;
        imageSwiper.slideTo(index);

        const progress = (index  / imageSwiper.slides.length) * 100;

        document.querySelectorAll('.swiper-progress').forEach((elem) => {
          elem.style.height = `${100 / imageSwiper.slides.length}%`;
          elem.style.top = `${progress}%`;
        });
      }
    });
  }

  document.addEventListener('scroll', handleScroll);
}

(function () {
  document.addEventListener('DOMContentLoaded', function() {
      initVerticalSwipers();
  });

  const shopify_events = ['shopify:block:select'];
  shopify_events.forEach(() => {
    initVerticalSwipers();
  });
})();
